import React, { FC } from 'react'
import { render } from 'react-dom'
import { SmpLandingPage } from 'views/app/SmpLandingPage/SmpLandingPage'

import { ContactSection } from './Footer/ContactSection/ContactSection'
import { LawSection } from './Footer/LawSection/LawSection'
import { LogosSection } from './Footer/LogosSection/LogosSection'
import { HamburgerMenu } from './HamburgerMenu/HamburgerMenu'

export interface RenderedFunctionComponent extends FC<DOMStringMap> {
  queryString: string
}

function initComponents (): void {
  const components: RenderedFunctionComponent[] = [
    HamburgerMenu, SmpLandingPage,

    // TODO: as long as we don't use these components inside other components
    // we should always keep it as last on the list to make sure that other
    // components have time to render
    ContactSection, LawSection,
    LogosSection,
  ]

  components.forEach((Component): void => {
    const elements: NodeListOf<HTMLDivElement> = document.querySelectorAll(Component.queryString)

    elements.forEach((element): void => {
      render(<Component { ...element.dataset } />, element)
    })
  })
}

initComponents()
